import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Amenity Details
 * (/property/:propertyID/amenity/:amenityID)
 */
export const amenityDetailsTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_AmenityDetails_Tabs_Title"),
    description: t("Tour_AmenityDetails_Tabs_Description"),
    target: () => queryTourTarget("amenity-details-tabs"),
    placement: "bottom",
  },
  {
    title: t("Tour_AmenityDetails_Availability_Title"),
    description: t("Tour_AmenityDetails_Availability_Description"),
    target: () => queryTourTarget("amenity-availability"),
    placement: "top",
  },
  {
    title: t("Tour_AmenityDetails_Reservations_Title"),
    description: t("Tour_AmenityDetails_Reservations_Description"),
    target: () => queryTourTarget("amenity-reservations"),
    placement: "top",
  },
  {
    title: t("Tour_AmenityDetails_Approve_Title"),
    description: t("Tour_AmenityDetails_Approve_Description"),
    target: () => queryTourTarget("amenity-reservation-approve"),
    placement: "left",
  },
];
